export default {
    timeTableSetting: 'ตั้งค่าเวลาการทำงาน',
    workday: 'วันทำงาน',
    specialWorkday: 'วันทำงานพิเศษ',
    groupHoliday: 'วันหยุดแบบกลุ่ม'
}
